import { useEffect, useRef } from "react";
import useTotals from "../hooks/use-totals";
import { isNumerical } from "../lib/utils";
import { useCropperStore } from "../store/cropper/cropper-store";
import { useProduct } from "../store/product";
import l10n, { media_l10n } from "../lib/l10n";
import useXHR from "../hooks/use-xhr";

const sqmt_price = parseFloat( media_l10n.sqmt_price );
const sold_per_pice = media_l10n.per_piece;
const sqmt = parseFloat( media_l10n.sqmt );
const template = media_l10n.template;
const intlConfig = { 
  // trailingZeroDisplay: 'stripIfInteger',
  minimumFractionDigits: 2 
};

function ProductPage() {
  const { getPricePerSquareMeter } = useTotals();
  const media = useCropperStore(s => s.preset.media);
  const product = useProduct(s => s.product);
  const wcPrice = useRef(document.querySelector('.summary.entry-summary .price'));
  const hiddenMediaField = useRef(document.querySelector('.wppr-cropper-required-fields [name="_wppr_cropper[media]"]'));
  const {post} = useXHR();
  
  function formatPrice(price) {
    return new Intl.NumberFormat(l10n.lang, intlConfig).format(price);
  }

  function priceTemplate(price) {
    return template.format
      .replace(/\%1\$s/, template.currency)
      .replace(/\%2\$s/, price);
  }

  async function queryPriceHTML() {
    const data = {
      action: "wppr_wholesale_get_price_html",
      product_id: media_l10n.product_id,
      media_sku: media,
      _wpnonce: media_l10n.wpnonce,
    };
    const response = await post(data);
    return response.data.success ? response.data.data.html : false;
  }

  useEffect(() => {
    if  (wcPrice.current && media) {
      (async() => {

        // Get the price
        if (l10n.u_role && l10n.u_role.indexOf('wholesale_') >= 0) {
          const postHTML = await queryPriceHTML();
          if (postHTML) {
            wcPrice.current.innerHTML = postHTML;
          }
        } else {

          // NOT Sold per piece, update price div
          if (!l10n?.p_is_sold_per_piece) {

            const pricePerSqmt = getPricePerSquareMeter();
            const price = pricePerSqmt * ((product.dimension_width / 100) * product.dimension_height) / 100;
            if (isNumerical(price)) {
              const formattedPrice = formatPrice(price);
              const priceHTML = priceTemplate(formattedPrice);
              wcPrice.current.innerHTML = priceHTML;
            }

          }
        }
        
        // Update hidden fields
        hiddenMediaField.current.setAttribute('value', media);
      })()
    }
  }, [media]);
}

export default ProductPage;